<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '详情'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-steps  :active="activeed" :simple="true" finish-status="success"  process-status="finish"
              v-show="!dataForm.id ? false : true">
      <el-step title="提交中"></el-step>
      <el-step title="处理中"></el-step>
      <el-step title="已评价"></el-step>
    </el-steps>
    <div style="
    float: right;padding: 10px 0;" v-show="!dataForm.id ? false : true">
      <el-button size="mini" @click="modifyHandl()" type="primary" v-show="isShow"
                 :disabled="isUp">
        修改工单
      </el-button>
      <el-button size="mini" type="warning" @click="finishHandle(dataForm.id)" v-show="isShow"
                 :disabled="isUp">结束工单
      </el-button>
      <el-button size="mini" type="danger" @click="deleteHandle(dataForm.id)" v-show="isShow">删除工单</el-button>
      <el-button size="mini" type="success" @click="forwardHandle(dataForm.id)" v-show="istShow" :disabled="isUp2">
        转发工单
      </el-button>
      <el-button size="mini" type="warning" @click="pendingHandle(dataForm.id)" v-show="istShow" :disabled="isUp2">
        处理工单
      </el-button>

    </div>
    <br>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px" style="clear: both;" v-if="dataForm.id == undefined">
      <el-form-item label="问题标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题"></el-input>
      </el-form-item>
      <el-form-item label="提交账号">
        <el-input v-model="dataForm.commitUserName" disabled></el-input>
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input v-model="dataForm.mobile" placeholder="联系方式"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="dataForm.email" placeholder="邮箱"></el-input>
      </el-form-item>
      <el-form-item label="QQ" prop="qq">
        <el-input v-model="dataForm.qq" placeholder="QQ"></el-input>
      </el-form-item>
      <el-form-item label="设备名称">
        <el-select v-model="dataForm.deviceId"  placeholder="请选择" style="width: 100%">
          <el-option
            v-for="item in deviceOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题描述">
        <el-input v-model="dataForm.content" placeholder="问题描述"></el-input>
      </el-form-item>
    </el-form>
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px" style="clear: both;" v-else>
      <div>
        <el-form-item label="提交时间" prop="createTime" style="width: 50%;float: left">
          <el-input v-model="dataForm.createTime"></el-input>
        </el-form-item>
        <el-form-item label="完成时间" prop="dealTime" style="width: 50%;float: left">
          <el-input v-model="dataForm.dealTime"></el-input>
        </el-form-item>
      </div>
      <el-form-item label="问题标题" prop="title">
        <el-input v-model="dataForm.title" placeholder="标题" :disabled="true"></el-input>
      </el-form-item>
      <el-form-item label="提交账号">
        <el-input v-model="dataForm.commitUserName" :disabled="yyds"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="mobile">
        <el-input v-model="dataForm.mobile" placeholder="联系方式" :disabled="yyds"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="dataForm.email" placeholder="邮箱" :disabled="yyds"></el-input>
      </el-form-item>
      <el-form-item label="QQ" prop="qq">
        <el-input v-model="dataForm.qq" placeholder="QQ" :disabled="yyds"></el-input>
      </el-form-item>
      <el-form-item label="设备名称">
        <el-select v-model="dataForm.deviceId" placeholder="请选择" :disabled="yyds" style="width: 100%">
          <el-option
            v-for="item in deviceOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="问题描述">
        <el-input v-model="dataForm.content" placeholder="问题描述" :disabled="yyds"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  inject: ['getDataList'],
  data() {
    return {
      yyds: true,
      visible: false,
      deviceOptions: [],
      dataForm: {
        id: 0,
        title: '',
        qq: '',
        email: '',
        content: '',
        mobile: '',
        deviceId:''
      },
      isShow: false,
      istShow: false,
      isUp: false,
      isUp2: false,
      dataRule: {
        title: [
          {required: true, message: '标题不能为空', trigger: 'blur'}
        ], deviceId: [
          {required: true, message: '设备名称不能为空', trigger: 'blur'}
        ],
      },
      activeed: 0,
    }
  },
  created() {
    this.getDeviceOptions();
  },
  methods: {
    init(id) {
      this.dataForm.id = id || null
      this.visible = true
      if (!id) {
        //从SessionStorage缓存中获取当前登录的用户信息
        let user = JSON.parse(sessionStorage.getItem("user") || "[]");
        this.dataForm.email = user.email
        this.dataForm.commitUserName = user.username
        this.dataForm.qq = user.qq
        this.dataForm.mobile = user.mobile
      }
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/workSheet/list`),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              id: id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              let user = JSON.parse(sessionStorage.getItem("user") || "[]")
              let order = data.data.rows[0]
              this.dataForm = order
              //是否显示
              if (order.commitUser == user.id) {
                this.isShow = true;
                this.istShow = false;
              } else {
                this.isShow = false;
                this.istShow = true;
              }
              //按钮是否可用
              if (order.status !== 3 && order.status !== 2) {
                this.isUp = true
              } else {
                this.isUp = false
              }
              if (order.status !== 2) {
                this.isUp2 = true
              } else {
                this.isUp2 = false
              }
              this.yyds = true;
              //控制进度条
              if (order.status === 2) {
                this.activeed = Number(1);
              } else if (order.status === 3) {
                this.activeed = Number(2);
              } else if (order.status === 4) {
                this.activeed = Number(2);
              } else if (order.status === 6) {
                this.activeed = Number(3);
              }
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/workSheet/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || null,
              'title': this.dataForm.title,
              'qq': this.dataForm.qq,
              'email': this.dataForm.email,
              'mobile': this.dataForm.mobile,
              'content': this.dataForm.content,
              'remark': this.dataForm.remark,
              'deviceId': this.dataForm.deviceId
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.visible = false
              this.$emit('refreshDataList')
              this.$message({
                message: data.msg,
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    },
    //修改工单
    modifyHandl() {
      this.yyds = false;
    },
    //处理工单
    pendingHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对工单-[id=${ids.join(',')}]进行[处理]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/workSheet/deal'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.visible = false;
            this.getDataList();
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //删除工单
    deleteHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对工单-[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/workSheet/delete'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
            this.visible = false;
            this.getDataList();
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //获取设备
    getDeviceOptions() {
      this.$http({
        url: this.$http.adornUrl('/device/option'),
        method: 'get',
      }).then(({data}) => {
        if (data && data.code === 200) {
          this.deviceOptions = data.data.deviceOption;
        }
      })
    },
    //结束工单
    finishHandle(id) {
      let ids = id ? [id] : this.dataListSelections.map(item => {
        return item.id
      })
      this.$confirm(`确定对工单-[id=${ids.join(',')}]进行[结束]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/workSheet/finish'),
          method: 'post',
          data: this.$http.adornData(ids, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.visible = false;
            this.getDataList();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
    //转发工单
    forwardHandle(id) {
      this.$confirm(`确定对工单-[id=${id}]进行[转发]操作?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http({
          url: this.$http.adornUrl('/workSheet/forward'),
          method: 'post',
          data: this.$http.adornData(id, false)
        }).then(({data}) => {
          if (data && data.code === 200) {
            this.visible = false;
            this.getDataList();
            this.$message({
              message: data.msg,
              type: 'success',
              duration: 1000,
            })
          } else {
            this.$message.error(data.msg)
          }
        })
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/handlecenter/workSheet-add-or-update.vue